module.exports = __webpack_public_path__ + "img/pc_snowball_effect.5d098478.png";